module.exports = __webpack_public_path__ + "img/logo-copamtv.beaca8ec.png";